import type { QueryHookOptions } from "@/shared/typings"

import { useUserBusinesses } from "./use-user-businesses"

export function useBusinessName(
	businessId: string,
	options?: QueryHookOptions,
) {
	const { data, isLoading, isError } = useUserBusinesses(options)

	const business = data?.businesses.find(
		(item) => item.internalID === businessId,
	)

	return {
		name: business?.name ?? "",
		isLoading,
		isError,
	}
}
